import React, { useContext } from 'react';
import { LangContext, MenuContext } from '../../../../context/DataContext';

function MenuLateralInterconexionBgpLocal() {
    const { myLang } = useContext(LangContext);
    const { activeAnchor, scrollToAnchor } = useContext(MenuContext);

    const menuConfig = {
        es: {
            title: 'Interconexión BGP a nivel local en la región de AméricaLatina y el Caribe',
            items: [
                { id: 'p1', anchor: 'resumen', label: 'Resumen' },
                { id: 'p2', anchor: 'introduccion', label: 'Introducción' },
                { id: 'p3', anchor: 'objetivos', label: 'Objetivos' },
                { id: 'p4', anchor: 'metodologia', label: 'Metodología' },
                { id: 'p5', anchor: 'resultados-preliminares', label: 'Resultados preliminares' },
                { id: 'p6', anchor: 'datos-por-ixp', label: 'Datos por IXP' },
                { id: 'p7', anchor: 'conclusiones', label: 'Conclusiones' }
            ]
        },
        en: {
            title: 'Local BGP Interconnection in Latin America and the Caribbean',
            items: [
                { id: 'p1', anchor: 'abstract', label: 'Abstract' },
                { id: 'p2', anchor: 'introduction', label: 'Introduction' },
                { id: 'p3', anchor: 'goals', label: 'Goals' },
                { id: 'p4', anchor: 'methodology', label: 'Methodology' },
                { id: 'p5', anchor: 'preliminary-findings', label: 'Preliminary Findings' },
                { id: 'p6', anchor: 'data-by-ixp', label: 'Data by IXP' },
                { id: 'p7', anchor: 'conclusions', label: 'Conclusions' }
            ]
        },
        pt: {
            title: 'Interconexão BGP no nível local na região da América Latina e o Caribe',
            items: [
                { id: 'p1', anchor: 'resumo', label: 'Resumo' },
                { id: 'p2', anchor: 'introducao', label: 'Introdução' },
                { id: 'p3', anchor: 'objetivos', label: 'Objetivos' },
                { id: 'p4', anchor: 'metodologia', label: 'Metodologia' },
                { id: 'p5', anchor: 'resultados-preliminares', label: 'Resultados preliminares' },
                { id: 'p6', anchor: 'dados-por-ixp', label: 'Dados por IXP' },
                { id: 'p7', anchor: 'conclusoes', label: 'Conclusões' }
            ]
        }
    };

    const currentMenu = menuConfig[myLang];

    if (!currentMenu) return null;

    return (
        <nav>
            <button>
                {currentMenu.title}
                <i className="fas fa-angle-down"></i>
            </button>
            <ul className="active">
                {currentMenu.items.map(({ id, anchor, label }) => (
                    <li key={id}>
                        <a
                            href={`#${anchor}`}
                            className={activeAnchor === id ? 'active' : null}
                            onClick={() => scrollToAnchor(id)}
                        >
                            {label}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default MenuLateralInterconexionBgpLocal;